import Loading from '@@/core/components/shared/Loading/Loading'
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBModal, VBToggle} from "bootstrap-vue";
import mixins from "@@/core/mixins/mixins";
import FormModal from "@@/core/libraries/form/FormModal";
import { method } from 'lodash';

export default {
  name: 'Poses',
  components: {
    Loading,BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, FormModal
  },
  directives: {
    'b-toggle': VBToggle, 'b-modal': VBModal,
  },
  mixins: [mixins],
  mounted() {
    this.loadItems();
  },
  data() {
    return {
      url: 'admin/pos',
      fields: [{
        key: 'id',
        label: 'شناسه'
      },
        {
          key: 'label',
          label: 'لیبل'
        },
        {
          key: 'terminal_id',
          label: 'شناسه ترمینال',
        },
        {
          key: 'status',
          label: 'وضعیت'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      status_options: [{
        name: 'فعال',
        value: '1'
      },
        {
          name: 'غیرفعال',
          value: '0'
        },
        {
          name: 'همه',
          value: ''
        },
      ],
    }
  },
  methods: {
    
  }
}
